import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

export const Error = ({ mensaje }) => {
    return (
        <div>
            {/* <h1>Error</h1> */}
            <p>{mensaje}</p>
        </div>
    );
};